<script lang="ts">
  import { Col, Modal, ModalBody, Row } from "sveltestrap"

  export let isOpen: boolean;
  export let toggle: Function;
  export let link: string;
</script>


<Modal class="pil-modal" isOpen={isOpen} {toggle}>
  <ModalBody class="pil-modal-body">
    <Row>
      <Col class="modal-title">
        <img class="icon-middle" src="/icons/check-circle.svg" alt="placeholder"/>
        Copied to clipboard
      </Col>
      <Col class="col-auto">
        <img class="icon-large" src="/icons/close.svg" alt="placeholder" on:click={toggle}/>
      </Col>
    </Row>
    <Row>
      <Col class="modal-sub-title">
        {link}
      </Col>
    </Row>
  </ModalBody>
</Modal>
